'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'diamond-half-stroke';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M288-16L288 74.5 469.5 256 288 437.5 288 528 560 256c-7.5-7.5-83.1-83.1-226.7-226.7L288-16z', 'M288-16L288 528 16 256 288-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;